

import Transaction from './Transaction.vue'
export {
  Transaction  // 助记词
}